import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {fadeInOnEnterAnimation, fadeOutOnLeaveAnimation} from 'angular-animations';
import {TrainingWithProgress} from '../../features/e-learning/e-learning.selectors';
import {TrainingLockReason} from '../../features/e-learning/learningpath/learningpath.component';

export interface TrainingCardOverlayData {
  training: TrainingWithProgress;
  isLocked?: TrainingLockReason | null;
}

@Component({
  selector: 'app-training-card-overlay',
  templateUrl: './training-card-overlay.component.html',
  styleUrls: ['./training-card-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInOnEnterAnimation({duration: 100}), fadeOutOnLeaveAnimation({duration: 100})],
})
export class TrainingCardOverlayComponent {
  dialogData: TrainingCardOverlayData;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: TrainingCardOverlayData,
    private readonly _dialogRef: MatDialogRef<TrainingCardOverlayComponent>,
    private readonly _router: Router,
  ) {
    this.dialogData = this._data;
  }

  get training() {
    return this.dialogData.training;
  }

  get isLocked() {
    return this.dialogData.isLocked;
  }

  get showPreview() {
    return this.isLocked || !this.training?.isAccessible;
  }

  close() {
    this._dialogRef.close();
  }

  handleStartTraining() {
    if (!this.showPreview) {
      this.close();
      this._router.navigate([this.getTrainingLink(this.training.slug)]);
    }
  }

  getTrainingLink(slug: string): string {
    return `/e-learning/trainings/${slug}`;
  }

  getLanguageHeader(): string {
    return `TRAININGS.LANGUAGE_HEADER.${this.training.language.toUpperCase()}`;
  }
}
